import { render, staticRenderFns } from "./CardapioCarrinho.vue?vue&type=template&id=7cb2647e&scoped=true&"
import script from "./CardapioCarrinho.vue?vue&type=script&lang=js&"
export * from "./CardapioCarrinho.vue?vue&type=script&lang=js&"
import style0 from "./CardapioCarrinho.vue?vue&type=style&index=0&id=7cb2647e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb2647e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VSelect,VSpacer,VTextField,VToolbar,VToolbarTitle})
